import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import ChooseIndustryModal from '../Modals/ChooseIndustryModal'
import SurveySearchStore from './SurveySearchStore'
import SearchLayout from '../Layouts/Search'
import Select from '../form/Select'
import DataTable from '../DataTable'
import Checkbox from '../form/Checkbox'
import Button from '../../UniformComponents/Button'
import LinkButton from '../../UniformComponents/LinkButton'
import AppLoading from '../AppLoading'

@observer
class SurveySearch extends Component {
    constructor(props) {
        super(props)
        this.surveySearchStore = new SurveySearchStore(props.store)
        this.state = {
            showChooseIndustry: false,
            loading: true
        }
        this.surveySearchStore.setColumns(props.surveySearchType, props.store)
    }

    async componentDidMount() {
        const { store, location, surveySearchType } = this.props
        const query = new URLSearchParams(location.search)
        store.breadcrumps = [
            {
                name: 'survey',
                url: '/survey',
                title: 'Survey',
            },
        ]
        await this.surveySearchStore.init(query, surveySearchType)
        this.setState({ loading: false })
    }

    openNewSurvey = (industryCode) => {
        const { store } = this.props
        store.goTo('full', `/survey/0/${industryCode}`)
    }

    openNewSurveyOrIndustrySelector = () => {
        const { store } = this.props
        const { industries } = store.client
        if (industries.length === 1) {
            this.openNewSurvey(industries[0].code)
        } else {
            this.setState({ showChooseIndustry: true })
        }
    }

    closeIndustryChoose = () => this.setState({ showChooseIndustry: false })

    renderFilterOptions = () => {
        const { surveySearchStore } = this
        const { respondentTypes, surveyTypes } = surveySearchStore
        const { surveySearchType } = this.props
        return (
            <Fragment>
                <div className="filter-texts">
                    <i className="filter-icon fa-regular fa-bars-filter" />
                    <p className="filter-text">{i18n.t('searchLayout.filters')}</p>
                </div>
                <fieldset className="filter">
                    <Select
                        label={i18n.t('event', 'Event')}
                        options={surveySearchStore.products}
                        onBlur={surveySearchStore.changeProduct}
                        value={surveySearchStore.product}
                    />
                </fieldset>
                <fieldset className="filter">
                    <Select
                        label={i18n.t('year', 'Year')}
                        options={surveySearchStore.years}
                        onBlur={surveySearchStore.changeYear}
                        value={surveySearchStore.year}
                    />
                </fieldset>
                <fieldset className="filter">
                    <legend className="legend-title">
                        {surveySearchType === 'maxbi' ? 'Maxbi status' : `${i18n.t('status', 'Status')}`}
                    </legend>
                    <div>
                        {(surveySearchStore.statuses.map(
                            (status) => (
                                <Checkbox
                                    onBlur={surveySearchStore.toggleStatus}
                                    checked={
                                        surveySearchStore.status.find((s) => (s === status.value))
                                    }
                                    name={status.value}
                                    label={status.label}
                                />
                            ),
                        ))}
                    </div>
                </fieldset>
                {surveySearchType === 'maxbi' ? null
                    : (
                        <>
                            <fieldset className="filter">
                                <legend className="legend-title">
                                    {i18n.t('survey_type', 'Survey type')}
                                </legend>
                                <div>
                                    {Object.keys(surveyTypes)
                                        .map((surveyType) => (
                                            <Checkbox
                                                onBlur={surveySearchStore.toggleSurveyType}
                                                checked={surveyTypes[surveyType].selected}
                                                name={surveyType}
                                                label={surveyTypes[surveyType].name}
                                            />
                                        ))}
                                </div>
                            </fieldset>
                            <fieldset className="filter">
                                <legend className="legend-title">
                                    {i18n.t('respondent_type', 'Respondent type')}
                                </legend>
                                <div>
                                    {Object.keys(respondentTypes)
                                        .map((respondentType) => (
                                            <Checkbox
                                                onBlur={surveySearchStore.toggleRespondentType}
                                                checked={respondentTypes[respondentType].selected}
                                                name={respondentType}
                                                label={respondentTypes[respondentType].name}
                                            />
                                        ))}
                                </div>
                            </fieldset>
                        </>
                    )}
            </Fragment>
        )
    }

    renderButtons = () => {
        const { surveySearchType } = this.props
        switch (surveySearchType) {
            case 'survey': return (
                <Button
                    cssClass="add-button primary regular"
                    onClick={this.openNewSurveyOrIndustrySelector}
                    icon="fa-light fa-circle-plus"
                    label={i18n.t('add_survey', 'Add new survey')}
                    disabled={this.surveySearchStore.industries.length === 0}
                />
            )
            case 'maxbi': return (
                <LinkButton
                    cssClass="primary regular"
                    href="/survey/0/CE?surveytype=EM"
                    icon="fa-light fa-circle-plus"
                    label={i18n.t('maxbiSearch.button.newMaxbiEntry', 'New Maxbi Entry')}
                    isExternal
                />
            )
            default: return null
        }
    }

    renderTablePanel = () => {
        const { surveySearchStore } = this
        return (
            <DataTable
                store={surveySearchStore}
                inMemory
                dataSet={surveySearchStore.filteredList || []}
                columns={surveySearchStore.columns}
            />
        )
    }

    renderGuide = () => (
        <div dangerouslySetInnerHTML={{
            __html: i18n.t('surveySearch.introText'),
        }}
        />
    )

    render() {
        const { surveySearchType } = this.props
        const { showChooseIndustry, loading } = this.state
        const { surveySearchStore } = this

        return (
            <Fragment>
                {!loading
                    ? (
                        <SearchLayout
                            pageTitle={surveySearchStore.searchSurveyType[surveySearchType]}
                            renderFilterOptions={this.renderFilterOptions}
                            renderButtons={this.renderButtons}
                            renderTablePanel={this.renderTablePanel}
                            renderGuide={this.renderGuide}
                            searchStore={surveySearchStore}
                        />
                    ) : <AppLoading noBg showTypewriter customMessage="Fetching your surveys..." />}

                <ChooseIndustryModal
                    show={showChooseIndustry}
                    onSelect={this.openNewSurvey}
                    onClose={this.closeIndustryChoose}
                    industries={surveySearchStore.industries}
                />
            </Fragment>
        )
    }
}

export default SurveySearch
